import { type PageStoreState, usePageStore } from '../../_shared/formStore'

import type { TTSFormValues } from '../_types/form'
import type { TTSPrefs, TTSUI } from './index'

type TTSStoreState = PageStoreState<TTSFormValues, TTSPrefs, TTSUI>

/** TTS 页面专用的 store 消费 hook */
export function useTTSStore<U>(selector: (state: TTSStoreState) => U): U {
  return usePageStore<TTSFormValues, TTSPrefs, TTSUI, U>(selector)
}
